// extracted by css-extract-rspack-plugin
export default {"splitTreeCompanyTabBadge":"splitTreeCompanyTabBadge-i4zlwB","loadingSkeleton":"loadingSkeleton-KkSRIo","industryPanel":"industryPanel-S6g6Yq"};